import { InjectionToken } from '@angular/core';

export const PROPERTIES_DATA = new InjectionToken<{}>('PROPERTIES_DATA');
